// extracted by mini-css-extract-plugin
module.exports = {"player":"player_player__i5ArV","controls":"player_controls__2C32z","duration":"player_duration__llBrD","title":"player_title__26uuW","progress":"player_progress__2W2RW"};